module.exports = __webpack_public_path__ + "img/73.6df5bf1c.png";